export default __webpack_public_path__ + "static/pic03-d29105f41b3c5a312c6e01828f501fe2.jpg";